module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("inline manifest")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', [_c('code', [_vm._v("manifest")]), _vm._v(" 文件为路径配置和异步组件名字列表，该做法可以减少一个"), _c('code', [_vm._v("http")]), _vm._v("请求。")]), _vm._v(" "), _c('p', [_vm._v("确保 "), _c('code', [_vm._v("vux-loader")]), _vm._v("更新到 "), _c('code', [_vm._v("^1.0.35")]), _vm._v("。")])]), _vm._v(" "), _c('h2', [_vm._v("修改 index.html 模板")]), _vm._v(" "), _c('p', [_vm._v("首先在页面的"), _c('code', [_vm._v("</body>")]), _vm._v("前加入代码：")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("%=htmlWebpackPlugin.files.webpackManifest%")]), _vm._v(">")]), _vm._v("\n")])]), _vm._v(" "), _c('h2', [_vm._v("配置 vux-loader")]), _vm._v(" "), _c('p', [_vm._v("在"), _c('code', [_vm._v("vux-loader")]), _vm._v("配置的 "), _c('code', [_vm._v("plugins")]), _vm._v(" 列表中加入"), _c('code', [_vm._v("inline-manifest")]), _vm._v("插件")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("plugins:[{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'inline-manifest'")]), _vm._v("\n}]\n")])]), _vm._v(" "), _c('p', [_vm._v("或者简化写法直接使用名字：")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("plugins:["), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'inline-manifest'")]), _vm._v("]\n")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4395ad9a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-4395ad9a"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/inline-manifest-302.vue
// module id = 2192
// module chunks = 432